import {initExerciseCard} from "../exercise-card/exercise-card";
import axios from "axios";

const classPrefix = 'result-exercises';
const dataPrefix = 'data-result-exercises';
const container = document.querySelector(`[${dataPrefix}]`);

if (container) resultExercises(container);

function resultExercises(container) {
    const loader = container.querySelector(`[${dataPrefix}-loader]`);
    const exerciseList = container.querySelector(`.${classPrefix}__list`);
    let currentVideoId = null;
    let recomendedVideos = [];

    init();
    function init() {
        currentVideoId = window.currentVideoId;
        fetchRecomendedVideos()
    }

    function initVideos() {
        recomendedVideos.forEach((video, index) => {
            initExerciseCard(exerciseList, video)
        })
        toggleLoader(false);
    }
    function fetchRecomendedVideos() {
        axios({
            method: 'GET',
            url: '/api/exercises/recomended',
            params: {
                video_id: currentVideoId
            }
        }).then((response) => {
            console.log(response.data.data)
            if (response.data.data)
            {
                recomendedVideos = response.data.data
                initVideos();
            }
        });
    }
    function toggleLoader(show) {
        loader.style.display = show ? 'flex' : 'none';
    }
}
